import React from 'react';
type Tome = {
  number: string;
  title: string;
  promise: string;
  badge: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'The Tryout & Placement Bible',
  promise: 'Run selections without drama, and with the paperwork to back every decision.',
  badge: 'bg-crimson',
  contents: ['The Fair-Play Framework and expectation-setting', 'Universal scorecards: stunts, tumbling, jumps, showmanship', 'The 3-day tryout script, minute by minute', 'The "No-Drama" notification templates', 'Placement logic by level (USASF / NFHS aligned)', 'The athlete–parent contract']
}, {
  number: '02',
  title: 'Pre-Season: The Foundation',
  promise: 'Build strength and clean technique before anybody goes in the air.',
  badge: 'bg-[#2F6FB5]',
  contents: ['The 8-week conditioning arc', 'Motion masterclass: sharp arms, instant visual cleanup', 'Jump toolbox: toe touches, pikes, hurdlers', '15-minute core and flexibility circuits', 'Foundational stunting: dip, drive, catch', 'Team bonding from day one']
}, {
  number: '03',
  title: 'Stunt & Pyramid Master Blueprint',
  promise: 'Level 1 through 6 progressions with the spotting built into every step.',
  badge: 'bg-gold-deep',
  contents: ['The spotting protocol, position by position', 'Level 1–2: thigh stands, prep levels, transitions', 'Level 3–4: extensions, single-leg, tosses', 'Level 5–6: inversions, full-ups, complex pyramids', 'The stunt troubleshooting matrix', 'Visual pyramid mapping that fills the mat']
}, {
  number: '04',
  title: 'Competition & Routine Strategy',
  promise: 'Read the scoresheet like a judge and clean the routine like one.',
  badge: 'bg-[#1C7A45]',
  contents: ['Scorecard decoding: difficulty vs execution', 'The 2:30 blueprint for routine structure', 'Cleaning drills for counts and sync', 'Transitions and formations without collisions', 'Performance and energy under fatigue', 'The competition day pack and warm-up timing']
}, {
  number: '05',
  title: 'The Sideline & Game Day Guide',
  promise: 'Own Friday nights: crowd-leading, formations and logistics.',
  badge: 'bg-[#5B2AA5]',
  contents: ['50 essential cheers and chants', 'Game day formations: football vs basketball', 'Leading pep rallies and school traditions', 'Sideline stunting on unmatted surfaces', 'Coordinating with the band', 'Logistics: transport, uniforms, weather calls']
}, {
  number: '06',
  title: "The Coach's Admin & Off-Season",
  promise: 'Get your Sundays back by systemizing the paperwork.',
  badge: 'bg-[#0E7490]',
  contents: ['The automated budget tracker', 'Parent management system and meeting calendar', 'Injury and incident report templates', 'The off-season retention plan', 'Banquet and awards planner', 'Coach self-care and certification path']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-white" data-id="element-203" data-mp="11neg0flevb6e">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-204" data-mp="16lfzv2qnveix">
        <div className="text-center" data-id="element-205" data-mp="1amjdrjp5f0hi">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-206" data-mp="1algo1f3kb436">
            The complete playbook
          </p>
          <h2 id="tomes-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-207" data-mp="iuu3i8q0rior">
            Inside the box set — six volumes
          </h2>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-208" data-mp="rofjtwhu180a">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col rounded-2xl border border-ice-dark bg-white p-6 shadow-card" data-id="element-209" data-mp="3ra42v92iy9su">
              <div className="flex items-center gap-2.5" data-id="element-210" data-mp="3c7ceq9eeeq8x">
                <span className={`flex h-8 w-8 items-center justify-center rounded-lg font-display text-lg text-white ${tome.badge}`} data-id="element-211" data-mp="3c5rjsio695aj">
                  {tome.number}
                </span>
                <span className="text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-212" data-mp="3h6ysql21wais">
                  Volume {tome.number}
                </span>
              </div>
              <h3 className="mt-3 text-lg font-bold leading-snug text-ink" data-id="element-213" data-mp="3v0gaq1f39f6p">
                {tome.title}
              </h3>
              <p className="mt-2 text-sm text-ink-soft" data-id="element-214" data-mp="8qvjwbz7cfsv">{tome.promise}</p>
              <ul className="mt-4 grid gap-2 border-t border-ice-dark pt-4" data-id="element-215" data-mp="8p2l1iutyzvf">
                {tome.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-ink" data-id="element-216" data-mp="2ai8lar1yo5k6">
                    <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-gold" data-id="element-217" data-mp="2akczc1tkqky6" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}